// extracted by mini-css-extract-plugin
module.exports = {"InfomationWrapper":"schemeSpec_InfomationWrapper__0Z2ue"};